// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCGHHiz6HzFQrBeo8Gz_0VFTZoase7uzcI",
  authDomain: "henok-s-org.firebaseapp.com",
  projectId: "henok-s-org",
  storageBucket: "henok-s-org.firebasestorage.app",
  messagingSenderId: "18217707204",
  appId: "1:18217707204:web:f0fcda23a199b292154b91",
  measurementId: "G-VYGFWVHBMH",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
